// extracted by mini-css-extract-plugin
module.exports = {"title":"PaymodeModal_diet_title__27npW"};